import { id } from "date-fns/locale";
import { DataBean } from "../DataBean";

export class Fortnight extends DataBean {
  public async getEmployeeFactorsByEmployee(
    year: any,
    month: any,
    accountID: any,
    valueType: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getEmployeeFactorsByEmployee_Number_Number_Number_Number",
      [year, month, accountID, valueType]
    );
  }
  public async getEmployeeFactorsByEmployeebypage(
    year: any,
    month: any,
    accountID: any,
    valueType: any,
    regexStr: any,
    page: any,
    recordsPerPage: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getEmployeeFactorsByEmployee_Number_Number_Number_Number_String_Number_Number",
      [year, month, accountID, valueType, regexStr, page, recordsPerPage]
    );
  }
  public async updateFortnightProperties(
    idItem: number,
    name: string,
    year: number,
    month: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "account.facts.Fortnight_updateFortnightProperties_Number_String_Number_Number",
      [idItem, name, year, month]
    );
  }

  public async addFortnightFactor(
    year: any,
    month: any,
    idAccount: any,
    factorName: any,
    value: any,
    idEmployee: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "account.facts.Fortnight_addFortnightFactor_Number_Number_Number_String_Number_Number",
      [year, month, idAccount, factorName, value, idEmployee]
    );
  }
  // public async addFortnightFactor(year: any, month:any ,idAccount:any, factorName: any,value:any,idEmployee:any): Promise<any> {
  //     return this.getCustomService("QuickDataERPCore","com.quickdataerp.bean.accountant.AccountantDocument_addAdvanceValueToCashRequest_Number_java.util.Date_String_Number_Number",
  //         [idCashRequest, cashRequestDate, observations, value, idEmployee]);
  // }getEmployeesByCostingCenter

  public async getEmployeesByCostingCenter(
    year: any,
    month: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getEmployeesByCostingCenter_Number_Number",
      [year, month]
    );
  }

  public async deleteFortnightFactor(
    year: any,
    month: any,
    idItem: any,
    idEmployee: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "boolean_deleteFortnightFactor_Number_Number_Number_Number",
      [year, month, idItem, idEmployee]
    );
  }

  public async createEmployeeBonusRow(
    idEmployeeBonus: number,
    idEmployee: number,
    idPayrollType: number,
    costingCenterCode: any,
    value: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "account.facts.Fortnight_createEmployeeBonusRow_Number_Number_Number_String_Number",
      [idEmployeeBonus, idEmployee, idPayrollType, costingCenterCode, value]
    );
  }

  public async createEmployeePaymentsTypeRow(
    idEmployeePaymentsType: number,
    idEmployee: number,
    idPayrollType: number,
    costingCenterCode: any,
    value: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "account.facts.Fortnight_createEmployeePaymentsTypeRow_Number_Number_Number_String_Number",
      [
        idEmployeePaymentsType,
        idEmployee,
        idPayrollType,
        costingCenterCode,
        value,
      ]
    );
  }

  public async createEmployeeDiscountTypeRow(
    idType: number,
    idEmployee: number,
    idPayrollType: number,
    value: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "account.facts.Fortnight_createEmployeeDiscountTypeRow_Number_Number_Number_Number",
      [idType, idEmployee, idPayrollType, value]
    );
  }

  public async createFinancialTaxRow(
    idTaxSchemeValue: number,
    idEmployee: number,
    idPayrollType: number,
    value: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "account.facts.Fortnight_createFinancialTaxRow_Number_Number_Number_Number",
      [idTaxSchemeValue, idEmployee, idPayrollType, value]
    );
  }

  public async createIncapacityPaymentForFundRow(
    incapacityType: number,
    idEmployee: number,
    idPayrollType: number,
    costingCenterCode: string,
    incapacityDays: number,
    value: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "account.facts.Fortnight_createIncapacityPaymentForFundRow_Number_Number_Number_String_Number_Number",
      [
        incapacityType,
        idEmployee,
        idPayrollType,
        costingCenterCode,
        incapacityDays,
        value,
      ]
    );
  }

  public async getFortnightIncapacitiesToLiquidate(
    year: number,
    month: number,
    welfareID: number,
    idProcess: number,
    idEmployee: number,
    fortnightType: number,
    page: number,
    recordsPerPage: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getFortnightIncapacitiesToLiquidate_Number_Number_Number_Number_Number_Number_Number_Number",
      [
        year,
        month,
        welfareID,
        idProcess,
        idEmployee,
        fortnightType,
        page,
        recordsPerPage,
      ]
    );
  }

  public async createIncapacityLiquidation(
    accountantDate: any,
    idDocument: number,
    documentDate: any,
    noveltyID: number,
    idWelfareEntity: number,
    description: string,
    idLoggedEmployee: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_createIncapacityLiquidation_java.util.Date_Number_java.util.Date_Number_Number_String_Number",
      [
        accountantDate,
        idDocument,
        documentDate,
        noveltyID,
        idWelfareEntity,
        description,
        idLoggedEmployee,
      ]
    );
  }

  public async getPdfAccountantDocument(
    documentLocation: number,
    mnemonic: string,
    date: any,
    idEmployee: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_getPdfAccountantDocument_Number_String_java.util.Date_Number",
      [documentLocation, mnemonic, date, idEmployee]
    );
  }
}
